/**
 * URL joining that does not care whether the caller left a trailing slash.
 *
 * `REACT_APP_BACKEND_URL` is written both ways across environments, and the
 * template-literal concatenation this replaces produced `http://host:5006auth/...`
 * whenever it was written without one.
 */
const joinUrl = (base: string, ...segments: string[]): string => {
  const root = (base ?? '').replace(/\/+$/, '')
  const path = segments
    .filter(Boolean)
    .map(segment => segment.replace(/^\/+|\/+$/g, ''))
    .filter(Boolean)
    .join('/')

  return path ? `${root}/${path}` : root
}

export const urlUtil = {joinUrl} as const
